import { Button, Typography } from '@mui/material';
import { Check } from '@ankr.com/ui';
import { t, tHTML } from '@ankr.com/common';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { checkoutRoutesConfig } from 'domains/checkout/routes';
import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';
import { useSignInWithRedirectURL } from 'modules/auth/hooks/useSignInWithRedirectURL';

import { usePremiumContentStyles } from './usePremiumContentStyles';

export const PremiumContent = () => {
  const { classes } = usePremiumContentStyles();

  const handleSignIn = useSignInWithRedirectURL({
    redirectURL: checkoutRoutesConfig.checkout.path,
  });
  const { isEnterprise, isPremium } = useAccountStatus();

  const navigate = useNavigate();

  useEffect(() => {
    const element = document.getElementById('sign-in');

    if (element) {
      element.onclick = handleSignIn;
    }
  }, [handleSignIn]);

  if (isPremium || isEnterprise) return null;

  const onClick = () => navigate(checkoutRoutesConfig.checkout.path);

  return (
    <>
      <div className={classes.root}>
        <div className={classes.content}>
          <Typography variant="subtitle2" className={classes.title}>
            {t('chains.upgrade-premium.title')}
          </Typography>

          <>
            <Typography variant="body3" className={classes.item}>
              <Check color="success" size="s" />
              {tHTML('chains.upgrade-premium.item-1')}
            </Typography>
            <Typography variant="body3" className={classes.item}>
              <Check color="success" size="s" />
              {t('chains.upgrade-premium.item-2')}
            </Typography>
            <Typography variant="body3" className={classes.item}>
              <Check color="success" size="s" />
              {t('chains.upgrade-premium.item-3')}
            </Typography>
            <Typography variant="body3" className={classes.item}>
              <Check color="success" size="s" />
              {t('chains.upgrade-premium.item-4')}
            </Typography>
          </>
          <Button
            className={classes.button}
            fullWidth
            onClick={onClick}
            size="small"
          >
            {t('chains.upgrade-premium.button')}
          </Button>
        </div>
      </div>
    </>
  );
};
